module.exports = __webpack_public_path__ + "static/media/Raichu_gaussian2.19f2e915.png";